import { useCallback } from 'react';

import { useMarginPositionsStore } from './useMarginPositionsStore';

const useMarginPosition = () => {
  const { positions } = useMarginPositionsStore();

  const getPositionById = useCallback(
    (id?: string) => {
      if (!positions || !id) return undefined;
      return positions.get(id);
    },
    [positions],
  );

  return {
    positions,
    getPositionById,
  };
};

export { useMarginPosition };
